import { memo } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DownloadGreen } from "assets/icons";

interface TripBackupReminderModalContentProps {}

export const TripBackupReminderModalContent = memo(
  ({}: TripBackupReminderModalContentProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
      <Stack direction="column" spacing={3}>
        <DownloadGreen
          style={{ alignSelf: "center", width: "64px", height: "64px" }}
        />
        <Typography variant="h6" alignSelf="center">
          {t("tripBackupReminder.title")}
        </Typography>
        <Typography variant="body1">
          {t("tripBackupReminder.description")}
        </Typography>
      </Stack>
    );
  }
);

TripBackupReminderModalContent.displayName = "TripBackupReminderModalContent";
